export const benefitsUpscale = [
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle1',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle2',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle3',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle4',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData_subtitle5',
	},
];
